const getPythonRequestURL = requestInfo => {
  const {
    functionName,
    projectID,
    queryParams,
    regionID
  } = requestInfo;
  const queryString = queryParams ? `?${new URLSearchParams(queryParams)}` : '';
  return `https://${regionID}-${projectID}.cloudfunctions.net/${functionName}${queryString}`;
};
const getPythonTargetURL = targetInfo => {
  const {
    functionName,
    projectID,
    regionID
  } = targetInfo;
  return `https://${regionID}-${projectID}.cloudfunctions.net/${functionName}`;
};

const queryParamsHasID = params => !!(params === null || params === void 0 ? void 0 : params.id);

const getHealthGorillaRequestURL = requestInfo => {
  const {
    baseURL,
    endpoint,
    queryParams
  } = requestInfo;
  let queryString = '';

  if (queryParams && queryParamsHasID(queryParams)) {
    queryString = `/${queryParams.id}`;
  } else if (queryParams) {
    queryString = `?${new URLSearchParams(queryParams).toString()}`;
  }

  return `${baseURL}/${endpoint}${queryString}`;
};

export { getHealthGorillaRequestURL, getPythonRequestURL, getPythonTargetURL };
